import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'promoStatus'
})
export class PromoStatusPipe implements PipeTransform {

  transform(value: any, args?: any): any {

    console.log( args)

    var startDate = new Date().getTime();
    var endDate = new Date(args).getTime();
    if(startDate > endDate){
      return "INACTIVE";
    }else{
      return "ACTIVE";          
    }
  }

}
